<template>
    <div class="nt_popup nqt__custom_dialo">
        <div class="nt_popup_container" :class="[{_mb: mobile}, {_pc: !mobile}]">
            <div class="nt_popup_content">
                <!-- Title -->
                <div class="nt_popup_title">
                    <div>{{$t('new.title86')}}</div>
                </div>

                <div class="nt_popup_content_list">
                    <div class="nt_popup_content_draft"></div>
                    <ul v-if="!loading">
                        <template v-for="item in noticeApprove">
                            <li :key="item.id" >
                                <div class="nt_popup_item nt_popup_act">
                                    <div class="nt_popup_item_content">
                                        <div class="nt_popup_item_content_c">
                                            <div class="nt_popup_item_content_c_g">
                                                <div class="nt_popup_item_content_text">
                                                    <div class="nt_popup_item_content_text_t">
                                                        <span class="nt_popup_item_content_text_t_th">
                                                            <span class="avtnus">{{$t("notification.common")}}</span>
                                                        </span>
                                                        <br />
                                                        <div class="mtsh"><strong>{{item.notiTitle}}</strong></div>
                                                        <div class="mtsh lhi"><span class="icon-point">&#9755;</span><strong>{{item.notiContents}}</strong></div>
                                                        <div class="mtsh_button">
                                                            <button class="btn-approve" @click="approve(item)">{{$t("new.title238")}}</button>
                                                            <button class="btn-unapprove" @click="unapprove(item)">{{$t("new.title239")}}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </template>

                        <template v-for="item in participatingList">
                            <li :key="item.lessonId" @click="jump(item)">
                                <div class="nt_popup_item nt_popup_act">
                                    <div class="nt_popup_item_content">
                                        <div class="nt_popup_item_content_c">
                                            <div class="nt_popup_item_content_c_g">
                                                <div class="nt_popup_item_content_text">
                                                    <div class="nt_popup_item_content_text_t">
                                                        <span class="nt_popup_item_content_text_t_th">
                                                            <span class="avtnus">{{$t("notification.common")}}</span>
                                                        </span>
                                                        <br />
                                                        <div class="mtsh"><strong>{{item.courseName}}</strong></div>
                                                        <div class="mtsh lhi"><span class="icon-point">&#9755;</span><strong>{{item.lessonName}}</strong></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </template>

                        <template v-for="item in unParticipatedList">
                            <li :key="item.lessonId" @click="jump(item)">
                                <div class="nt_popup_item nt_popup_act">
                                    <div class="nt_popup_item_content">
                                        <div class="nt_popup_item_content_c">
                                            <div class="nt_popup_item_content_c_g">
                                                <div class="nt_popup_item_content_text">
                                                    <div class="nt_popup_item_content_text_t">
                                                        <span class="nt_popup_item_content_text_t_th">
                                                            <span>{{$t("notification.common")}}</span>
                                                        </span>
                                                        <br />
                                                        <div class="mtsh"><strong>{{item.courseName}}</strong></div>
                                                        <div class="mtsh lhi"><span class="icon-point">&#9755;</span><strong>{{item.lessonName}}</strong></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </template>
                    </ul>

                    <!-- Loading -->
                    <loading class="loading--lesson" :showLoading="loading" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import loading from "@/components/loading/loading";

    export default {
        data() {
            return {
                userID: null,
                languageType: null,
                notifications: [],
                loading: true,
                noticeApprove: []
            };
        },
        components: {
            loading,
        },
        computed: {

            unParticipatedList() {
                return this.notifications.filter(item => Number(item.status) == 1);
            },

            participatingList() {
                return this.notifications.filter(item => Number(item.status) == 0);
            },

            // Vuex
            ...mapState({
                mobile: (state) => state.header.mobile,
                totalComment: (state) => state.header.totalComment
            }),
        },
        created () {
            this.init();
        },
        // watch: {
        //     totalComment (total) {
        //         this.init();
        //     }
        // },
        methods: {
            init: async function () {
                let userID  = this.$attrs.userId || window.sessionStorage.getItem("id");
                let loginName = window.sessionStorage.getItem("loginName");
                if (userID && loginName) {
                    this.languageType = this.$lang();
                    this.notifications = await this.getNotifications({userId: userID, languageType: this.languageType});
                    this.noticeApprove = await this.getNoticeApprove({userId: userID, loginName: loginName, languageType: this.languageType})
                }
                this.loading = false;
            },

            getNotifications: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getCourseCommentListNew", params)
                        .then((response) => {
                            let results = [];
                            this.setTotalComment(response.data.length);
                            if (response.data.length) {
                                var unique = [];
                                response.data.map(x => unique.filter(a => a.lessonId == x.lessonId && a.courseId == x.courseId).length > 0 ? null : unique.push(x));
                                if (unique.length) {
                                    const data = unique.sort(function (a, b) {
                                        return parseInt(b.lessonId) - parseInt(a.lessonId);
                                    });
                                    results = data;
                                } else {
                                    results = [];
                                }
                            } else {
                                results = [];
                            }

                            resolve(results);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },
            getNoticeApprove: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/notification/getNoticeApprove", params)
                        .then((response) => {
                            var results = [];
                            this.setTotalComment(this.totalComment + response.data.length);
                            if (response.data.length) {
                                results = response.data;
                            } else {
                                results = [];
                            }
                            resolve(results);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            getStatus: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/coursesPurchase/getCoursePurchaseDetails", params)
                        .then((response) => {
                            resolve(Number(response.data.startStudy));
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            redirect: function (outlineInfo) {
                this.$router.push({
                    path: "/home/curriculum/lesson",
                    query: {
                        outlineInfo: JSON.stringify(outlineInfo),
                    },
                });
                this.$emit("close", true);
            },

            jump: async function (data) {

                // Get status
                let status = await this.getStatus({courseId: data.courseId, languageType: this.languageType});

                let params = {
                    courseId: data.courseId,
                    courseName: data.courseName,
                    activeID: data.lessonId,
                    redirectType: 1
                }
                if (status != 0) {
                    this.setTotalComment(this.totalComment -1);
                    this.redirect(params);
                } else {
                    let h = this.$createElement;
                    this.$msgbox({
                        title: this.$t("js.hint"),
                        message: h("div", null, [h("p", null, this.$t("notification.title1")), h("p", null, this.$t("notification.title2"))]),
                        showCancelButton: true,
                        confirmButtonClass: "xam_duP",
                        confirmButtonText: this.$t("home.clickJump"),
                        cancelButtonText: this.$t("js.cancel"),
                        beforeClose: async (action, instance, done) => {
                            if (action === "confirm") {
                                instance.confirmButtonLoading = true;
                                instance.confirmButtonText = "Loading...";

                                await this.startStudy({courseId: data.courseId});
                                await this.updateTime({courseId: data.courseId});

                                // Đóng thông báo xác nhận
                                setTimeout(() => {
                                    done();
                                    setTimeout(() => {
                                        instance.confirmButtonLoading = false;
                                    }, 300);
                                }, 500);
                            } else {
                                done();
                            }
                        },
                    })
                    .then(() => {
		    	this.setTotalComment(this.totalComment -1);
                        this.redirect(params);
                    })
                    .catch(() => {});
                }
            },
           approve: function (data) {
                let params = {
                    userId: data.id,
                    loginName: window.sessionStorage.getItem("loginName"),
                    languageType: this.$lang(),
                    companyId: window.sessionStorage.getItem("companyId")
                }
                this.$msgbox({
                    
                    title: this.$t("new.title236"),
                    message: data.notiContents,
                    showCancelButton: true,
                    confirmButtonClass: "xam_duP",
                    cancelButtonText: this.$t("js.cancel"),
                    confirmButtonText: this.$t("js.hint"),
                    beforeClose: async (action, instance, done) => {
                        if (action == "confirm") {
                            return new Promise((resolve, reject) => {
                                done();
                                this.$api
                                    .post("/notification/approveUser", params)
                                    .then((response) => {
                                        resolve(response.data);
                                        this.$router.go();
                                    })
                                    .catch((err) => {
                                        reject(err.response);
                                    });
                            });
                        } else {
                            done();
                        }
                    },
                })
                .then(() => {
                    this.setTotalComment(this.totalComment -1);
                })
                .catch(() => {});
            },
            unapprove: function (data) {
                let params = {
                    userId: data.id,
                    loginName: window.sessionStorage.getItem("loginName"),
                    languageType: this.$lang(),
                    companyId: window.sessionStorage.getItem("companyId")
                }
                this.$msgbox({
                    title: this.$t("new.title237"),
                    message: data.notiContents2,
                    showCancelButton: true,
                    confirmButtonClass: "xam_duP",
                    confirmButtonText: this.$t("js.hint"),
                    cancelButtonText: this.$t("js.cancel"),
                    beforeClose: async (action, instance, done) => {
                        if (action == "confirm") {
                            return new Promise((resolve, reject) => {
                                done();
                                this.$api
                                    .post("/notification/unapproveUser", params)
                                    .then((response) => {
                                        resolve(response.data);
                                        this.$router.go();
                                    })
                                    .catch((err) => {
                                        reject(err.response);
                                    });
                            });
                        } else {
                            done();
                        }
                    },
                })
                .then(() => {
                    this.setTotalComment(this.totalComment -1);
                })
                .catch(() => {});
            },


            startStudy: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/coursesPurchase/startStudy", params)
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            updateTime: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/coursesPurchase/updateStudyTime", params)
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },
            ...mapMutations("header", ["setTotalComment"]),
        },
    };
</script>

<style scoped>
    /* .nt_popup {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", メイリオ, Meiryo,
            "ＭＳ Ｐゴシック", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    } */

    .nt_popup_container {
        margin-top: 80px;
        box-shadow: 0 1px 10px 1px rgb(0 0 0 / 45%);
        transition: top 0.1s linear 0s;
        margin-right: 8px;
        border-radius: 10px;
        box-sizing: border-box;
        right: 0;
        position: absolute;
        background-color: #fff;
        margin-bottom: 8px;
        overflow: auto;
    }

    .nt_popup_content {
        height: 100%;
        flex-direction: column;
        margin-bottom: 0;
        margin-top: 0;
        display: flex;
    }

    .nt_popup_title {
        padding: 10px 0;
        font-size: 16px;
    }

    .nt_popup_title > div {
        font-size: 32px;
        text-align: center;
        word-wrap: break-word;
        font-weight: 700;
        color: #111;
        display: block;
    }

    .nt_popup_content_list {
        clear: both;
        max-height: calc(100vh - 460px);
        overflow: auto;
		overflow-x: hidden;
        word-break: break-word;
        display: block;
    }

    ::-webkit-scrollbar-thumb:horizontal {
        background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.44, rgb(112, 161, 155)), color-stop(0.72, rgb(30, 144, 255)), color-stop(0.86, rgb(30, 144, 255)));
    }
    ::-webkit-scrollbar-thumb:vertical {
        background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.44, rgb(112, 161, 155)), color-stop(0.72, rgb(30, 144, 255)), color-stop(0.86, rgb(30, 144, 255)));
    }

    .nt_popup_content_draft {
        width: 344px;
    }

    .nt_popup_item {
        width: 100%;
        cursor: pointer;
        margin-right: 0;
        margin-left: 0;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 0px 4px 4px 4px;
        flex-direction: column;
        transition: 0.5s ease;
        line-height: 1.4;
    }

    .nt_popup_item_content {
        width: 100%;
        flex-direction: row;
        margin-left: 0;
        margin-right: 0;
    }

    .nt_popup_item_content_c {
        border-radius: 0;
        display: block;
        cursor: pointer;
        width: 100%;
        color: inherit;
        transition: transform 85ms ease-out;
    }

    .nt_popup_item_content_c_g {
        align-items: center;
        flex-direction: row;
        margin-left: 0;
        margin-right: 0;
        display: flex;
    }

    .nt_popup_item_content_c_g_avt {
        width: 48px;
        margin-right: 8px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
    }

    .nt_popup_item_content_c_g_avt_z {
        height: 48px;
        width: 48px;
        box-sizing: border-box;
    }

    .nt_popup_item_content_c_g_avt_z_a {
        justify-content: space-between;
        width: 48px;
        flex-direction: row;
        margin-left: 0;
        margin-right: 0;
        display: flex;
    }

    .nt_popup_item_content_c_g_avt_z_a_h {
        width: 100%;
        border-radius: 50%;
        box-sizing: border-box;
        position: relative;
        background-color: #fff;
    }

    .nt_popup_item_content_c_g_avt_z_a_h_h {
        padding-bottom: 100%;
        border-radius: 50%;
        box-sizing: border-box;
        position: relative;
        background-color: #efefef;
    }

    .nt_popup_item_content_c_g_avt_z_a_h_h_h {
        justify-content: center;
        box-sizing: border-box;
        left: 0;
        bottom: 0;
        right: 0;
        top: 0;
        position: absolute;
        display: flex;
        flex-direction: row;
    }
    .avtnus {
        color: red !important;
    }
    .mtsh {
        color: #0071c5 !important;
        font-size: 12px !important;
        padding-left: 10px;
    }
    .mtsh_button {
        padding-top: 4px;
    }
    .nt_popup_item_content_c_g_avt_z_a_h_h_h .svg text {
        font-weight: 700;
    }

    .nt_popup_item_content_c_g_avt_z_a_h_h_h img {
        border-radius: 50%;
        width: 48px;
    }

    .nt_popup_item_content_text {
        margin-left: 0;
        box-sizing: border-box;
        display: flex;
        -ms-flex-direction: row;
        flex-direction: row;
    }

    .nt_popup_item_content_text_t {
        box-sizing: border-box;
    }

    .nt_popup_item_content_text_t span {
        text-align: left;
        font-size: 14px;
        word-wrap: break-word;
        font-weight: 700;
        -webkit-font-smoothing: antialiased;
        color: #111;
    }

    .nt_popup_act {
        margin-bottom: 8px;
    }

    .icon-point {
        font-size: 16px !important;
        color: #0071c5 !important;
        margin-right: 5px !important;
    }
    .nt_popup_act:hover {
        background-color: #efefef;
    }

    ul,
    ul li {
        padding: 0;
    }

    ul li {
        list-style: none;
        text-align: left;
        height: unset !important;
        display: block !important;
        line-height: normal !important;
    }

    ul {
        margin: 0;
        display: block;
        min-width: auto;
        width: 100%;
    }

    .nt_popup_item_title {
        font-size: 16px;
        font-weight: 700;
        color: #111;
        display: block;
        text-align: left;
        height: unset !important;
    }

    .loading--lesson {
        position: absolute !important;
    }

    ._mb {
        bottom: 70px !important;
        margin: 0 5px !important;
        position: fixed !important;
        width: 260px;
        z-index: 3;
        overflow: hidden;
    }
    ._pc {
        top: 70px;
        width: 300px;
        margin: 0;
        z-index: 3;
        overflow: hidden;
    }
    .lhi {
        line-height: 1.4;
    }
    .btn-approve{
        background-color: #0071c5;
        color: #fff;
        width: 120px;
        height: 24px;
        border: #0071c5;
    }
    .btn-unapprove{
        background-color: #7f8c9d;
        color: #fff;
        width: 120px;
        height: 24px;
        border: #7f8c9d;
    }
</style>



// WEBPACK FOOTER //
// src/components/popup/notification.vue